export const name = 'addressInput' as const
